// extracted by mini-css-extract-plugin
export default {"Partners":"Partners_Partners__DELNO","SliderItem":"Partners_SliderItem__d+xRH","SliderItemFlex":"Partners_SliderItemFlex__b6W0t"};